const docEle = document.documentElement;

export function setCssVar(prop, val, dom = docEle) {
  dom.style.setProperty(prop, val);
}
